import React, {Component} from 'react';
import "./UserAnalytics.css";
import {PieChart, Pie, Cell, ResponsiveContainer} from 'recharts';
const RADIAN = Math.PI / 180;

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#1ac0c6', '#ff6150'];

// const COLORS = ['#575D6B', '#008EBA', '#10EBCA', '#DB4437'];



const smallHeading = {
    fontWeight: '500',
    fontSize: '14px',
    color: '#000',
    margin: '0px'
  };

export default class PieCard extends Component {
    // Function for Creating Labels on Pie Graphs
    constructor(props) {
        super(props)
        this.renderCustomizedLabel = this.renderCustomizedLabel.bind(this)
    }



    renderCustomizedLabel(args) {
        const {cx, cy, midAngle, innerRadius, outerRadius, percent, index} = args
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            // <div style={{ backgroundColor: 'black', width: 'auto', height: '10px' }}>
            <text
                x={x} y={y} fill="black" fontWeight={500} fontSize="calc(10px + 0.2vw)" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${this.props.data[index].label} ${(percent * 100).toFixed(0)}%`}
            </text>
            // </div>
        );
    };
    render() {
        let colors = COLORS
        if (this.props.colors){
            colors = this.props.colors
        }
        return (
            <div style={{
                border: '1px solid #E4EBF6', 
                borderRadius: '8px',
                padding: '25px 20px 30px 20px',
                backgroundColor: '#fff',
                marginTop: '20px',
                height: 'auto',
                width: 'auto',
                // paddingBottom: '20px'

            }}>
                <p style={{...smallHeading, marginBottom: '-15px', textAlign: 'center' }}>{this.props.title}</p>
                
                <ResponsiveContainer width="100%" height={250}>
                {(()  => {
                    if (this.props.data.length === 0) {
                        return (<p style={{textAlign: 'center', color: 'var(--secondary-text-color)', margin: '70px auto 0px auto', fontSize: '14px', fontWeight: '500'}}>No data</p>)
                    } else {
                        return (
                            <PieChart onMouseEnter={this.onPieEnter}>
                                <Pie
                                    stroke="none"
                                    data={this.props.data}
                                    nameKey='name'
                                    cx={"50%"}
                                    cy={"50%"}
                                    innerRadius={35}
                                    outerRadius={85}
                                    fill="#8884d8"
                                    style={{border: 'none', color: 'black'}}
                                    labelLine={false}
                                    label={this.renderCustomizedLabel}
                                    paddingAngle={2}
                                    dataKey="value"
                                >
                                    {this.props.data.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]}/>
                                    ))}
                                </Pie>
                            </PieChart>
                        )
                    }
                })()}
                </ResponsiveContainer>

            </div>
        )
    }
}